import { useQuery } from "@tanstack/react-query";

import { getFootprintingFarmFootprintsByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN } from "consts";

export const useGetFootprintingFarmFootprintByPrimaryDataId = (primaryDataId?: string, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;

  return useQuery({
    queryKey: [FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, primaryDataId, isAdmin],
    // TODO: Add the service function for public fetching farm footprint by PDID
    queryFn: () => getFootprintingFarmFootprintsByPrimaryDataIdAdmin(primaryDataId ?? ""),
    enabled: enabled && isAdmin && !!primaryDataId,
    staleTime: 0,
    refetchOnMount: "always",
  });
};
